import { useQuery } from "@tanstack/react-query";
import { Controller } from "react-hook-form";
import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import { FieldError } from "@/components/ui/field";
import CampaignService from "services/Campaign";
import CampaignStatusPresetService from "services/CampaignStatusPreset";
import CampaignStatusSelector from "routes/campaign_status_presets/components/CampaignStatusSelector";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  campaign_statuses: z
    .array(z.any())
    .min(1, "Add at least one Campaign Status"),
});

const CampaignStatusPresetForm = ({ preset, onSuccess }) => {
  const { data: allCampaignStatuses = [] } = useQuery({
    queryKey: ["campaign-statuses"],
    queryFn: () => CampaignService.getCampaignStatuses(),
  });

  const handleSubmit = async values => {
    if (preset) {
      await CampaignStatusPresetService.editCampaignStatusPreset(
        preset.id,
        values.name,
        values.campaign_statuses
      );
    } else {
      await CampaignStatusPresetService.createCampaignStatusPreset(
        values.name,
        values.campaign_statuses
      );
    }
    toast.success("Preset saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: preset?.name || "",
        campaign_statuses: preset?.info?.campaign_statuses || [],
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required />
      <Controller
        name="campaign_statuses"
        render={({ field, fieldState }) => (
          <div>
            <CampaignStatusSelector
              campaignStatuses={field.value}
              setCampaignStatuses={field.onChange}
              allCampaignStatuses={allCampaignStatuses}
            />
            <FieldError>{fieldState.error?.message}</FieldError>
          </div>
        )}
      />
    </BaseForm>
  );
};

export default CampaignStatusPresetForm;
